module.exports = __webpack_public_path__ + "img/logo_pupr.a96dc591.svg";